import React from "react";
import { RouteProp, useRoute } from "@react-navigation/native";
import { Tabs, useAuth } from "@venuepos/react-common";
import { useTranslation } from "locales";
import { RootStackParamList } from "../../navigation";
import { AdminContainer } from "../container";
import { ApprovalListScreen } from "./approval/approval-list-screen";
import { ApprovalTokenGroupTab } from "./token-group/approval-token-group-tab";
import { ApprovalTokenTab } from "./token/approval-token-tab";

export function Approvals() {
    const auth = useAuth();
    auth.enforce("merchant.approval");

    const [t] = useTranslation();

    const route = useRoute<RouteProp<RootStackParamList, "APPROVALS">>();
    const index = route.params?.tabIndex || 0;

    return (
        <AdminContainer>
            <Tabs
                labels={[
                    t("backoffice.approval.approvals", "Approvals"),
                    t("backoffice.approval.tokens", "Tokens"),
                    t("backoffice.approval.token_groups", "Token groups"),
                ]}
                index={index}
            >
                <ApprovalListScreen />
                <ApprovalTokenTab />
                <ApprovalTokenGroupTab />
            </Tabs>
        </AdminContainer>
    );
}
